export default "__VITE_ASSET__CbURfPDs__"